import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w-full border-b border-neutral-800" }
const _hoisted_2 = { class: "flex items-center justify-start space-x-4 w-full py-4 cursor-auto" }
const _hoisted_3 = {
  key: 2,
  class: "block"
}
const _hoisted_4 = { class: "block font-semibold flex-grow flex-shrink-0" }
const _hoisted_5 = {
  key: 0,
  class: "block truncate text-neutral-400 text-right"
}
const _hoisted_6 = { class: "relative py-4 pt-0" }
const _hoisted_7 = {
  key: 0,
  class: "absolute z-10 inset-0 flex flex-col justify-center bg-neutral-900 p-4 pt-0"
}
const _hoisted_8 = { class: "border border-red-600 p-4 rounded" }
const _hoisted_9 = { class: "text-red-600 txt-sm truncate" }

import { computed } from "vue";
import { CheckIcon, XMarkIcon } from "@heroicons/vue/24/outline";


export default /*#__PURE__*/_defineComponent({
  __name: 'StepperItem',
  props: [
    "id",
    "title",
    "subtitle",
    "index",
    "isCurrent",
    "isSuccess",
    "error",
],
  setup(__props) {

const props = __props



const classes = computed(() => {
    return {
        "!bg-green-600 !text-neutral-50": !!props.isSuccess,
        "!bg-red-500 !text-neutral-50": !!props.error,
        "!bg-blue !text-neutral-50": !!props.isCurrent && !props.error,
    };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["inline-flex items-center justify-center w-6 h-6 text-sm rounded-full overflow-hidden bg-neutral-700 text-neutral-400 flex-shrink-0", _unref(classes)])
      }, [
        (!!__props.error)
          ? (_openBlock(), _createBlock(_unref(XMarkIcon), {
              key: 0,
              class: "block w-3 h-3"
            }))
          : (__props.isSuccess)
            ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                key: 1,
                class: "block w-3 h-3"
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.index), 1))
      ], 2),
      _createElementVNode("h5", _hoisted_4, _toDisplayString(__props.title), 1),
      (__props.subtitle && __props.isSuccess)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.subtitle), 1))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_6, [
        (__props.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", _hoisted_9, _toDisplayString(__props.error), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ])
    ], 512), [
      [_vShow, __props.isCurrent]
    ])
  ]))
}
}

})